<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <div class="container text-left mt-2 mb-2 text-playgame">
        กฎระเบียบ
      </div>
      <div class="container">
        <img
          class="w-100"
          height="auto"
          src="../assets/04-06/termofuse/term-of-use.png"
          alt="faq-img"
        />
      </div>
      <div class="container text-left" style="color:white">
        <div class="termofuse-text mt-3 mb-3">
          1. กฎกติกา ทั้งหมดจะถูกเผยแพร่หน้าเว็บไซต์ AMBPoker
          ซึ่งถือว่าสมาชิกทุกท่านรับรู้และทำความเข้าใจโดย
          สมบูรณ์แล้วก่อนการเล่นเกมส์ท่านควรศึกษารูปแบบการเดิมพันในเกมส์ที่ท่านต้องการเล่นให้เข้าใจ
        </div>
        <div class="termofuse-text mt-3 mb-3">
          2. ก่อนทำการเล่น เมื่อเล่นหรือวางเดิมพันแล้วถือเป็นที่สิ้นสุด
          ทางเว็บของเราจะไม่รับผิดชอบ ในการขอเงินคืนในทุกกรณี NO REFUND
        </div>
        <div class="termofuse-text mt-3 mb-3">
          3. ห้ามใช้โปรแกรมโกง หรือ โปรแกรมช่วยในการเล่น ใด ๆ ก็ตาม หากตรวจพบ
          จะมีการระงับการเป็นสมาชิก และจะระงับการ ฝาก-ถอน เงินจากระบบโดยทันที
        </div>
        <div class="termofuse-text mt-3 mb-3">
          4. ห้าม! สมัครสมาชิกซ้ำซ้อน เพื่อรับผลประโยชน์ โปรโมชั่น ของขวัญ
          ทางเว็บไซต์มีระบบตรวจเช็คสถานภาพของสมาชิกทุกท่าน หากตรวจพบ
          จะมีการระงับการเป็นสมาชิก และจะระงับการ ฝาก-ถอน เงินจากระบบโดยทันที
          หรือหากมีหลาย User เกินไปจะมีการระงับสมาชิก User
          ทั้งหมดภายใต้ชื่อของคน ๆ เดียวกัน
        </div>
        <div class="termofuse-text mt-3 mb-3">
          5. เมื่อได้รับรหัสผ่านในการเข้าหน้าเว็บไซต์เพื่อเล่นเกมส์ครั้งแรก
          ควรเปลี่ยนรหัสผ่านทันที และควรออกจากระบบทุกครั้งเมื่อสิ้นสุดการเล่น
          เพื่อป้องกันการเข้าเล่นเกมส์จากบุคคลอื่น
          ทางเว็บจะไม่รับผิดชอบหากมีบุคคลเข้าเล่นเกมส์ในรหัสของท่าน
        </div>
        <div class="termofuse-text mt-3 mb-3">
          6. Ambpoker เป็นเจ้าของสิทธิ์ในเนื้อหาทั้งหมดรวมถึง
          ซอฟแวร์รูปภาพและข้อความเนื้อหาทางเว็บไซต์ และทรัพย์สินทางปัญญา
          รหัสซอฟแวร์โครงสร้างและองค์กร ห้ามมิให้ผู้ใดคัดลอก
          แจกจ่ายรวมถึงเผยแพร่ แยกส่วน ดัดแปลง เพื่อส่งมอบ ให้กับบุคคลที่ 3
          ผ่านเครือข่ายคอมพิวเตอร์หรืออื่น ๆ
        </div>
        <div class="termofuse-text mt-3 mb-3">
          7. การเดิมพันทั้งหมดที่เกิดขึ้นระหว่างการเล่นของท่านที่มีผู้เล่นหลายคน
          เป็นการเดิมพันที่เกิดขึ้นกับการเล่นกับผู้อื่น
          ซึ่งไม่ใช่การเดิมพันที่เกี่ยวข้องกับทางเว็บไซต์ของเรา
          ทางเราให้บริการเกมส์ที่มีผู้เล่นหลายคน
          หากเกิดข้อผิดพลาดระหว่างตัวผู้เล่นทางเราจะไม่รับผิดชอบใด ๆ
          ที่ไม่เกี่ยวข้องกับทางเว็บไซต์
        </div>
      </div>
    </div>
    <div class="maincontent-bg-end"></div>
  </div>
</template>

<script>
export default {
  name: 'termofuse',
};
</script>

<style scoped></style>
